export const ZALO_OUT_OF_MONEY = 'ZALO_OUT_OF_MONEY';
// Trang chủ ZBS: link theo accountId thì người khác mở không vào được
export const ZALO_ACCOUNT_URL = 'https://account.zalo.solutions/';

// Lỗi hết tiền Zalo thì hiện popup kèm link thay vì toast. Trả true nếu đã xử lý.
export const handleZaloOutOfMoney = async (vm, error) => {
  if (error?.code !== ZALO_OUT_OF_MONEY) return false;

  const openLink = await vm.$swal({
    title: 'Tài khoản Zalo hết tiền',
    text:
      `${error.message}\nTruy cập ${ZALO_ACCOUNT_URL} để xem chi tiết, ` +
      'hoặc thử mua nhóm thủ công bằng OA Manager.',
    icon: 'error',
    buttons: {
      cancel: { text: 'Đóng', value: false, visible: true, className: '', closeModal: true },
      confirm: { text: 'Xem chi tiết', value: true, visible: true, className: '', closeModal: true },
    },
  });
  if (openLink) window.open(ZALO_ACCOUNT_URL, '_blank', 'noopener');
  return true;
};
